module.exports = __webpack_public_path__ + "img/Day4_final_lazy.d7a4c396.jpg";